module.exports = __webpack_public_path__ + "img/l1.b5c2d812.jpg";